<template>
  <div class="cycle_cutting_rule">

    <div class="header between_border">
      <div class="info">
        <div class="clazz_name">{{ clazz.clazz_name }}</div>
        <div class="cycle_range">
          {{ clazz.start_time_format2 }} ~ {{ clazz.end_time_format2 }}
        </div>
      </div>
      <div class="limit">
        <div class="limit_item">
          <div class="one"><span>{{ clazz.week_num }}</span> 周</div>
          <div class="two">总周数</div>
        </div>
      </div>
    </div>

    <van-collapse class="clazz_cycle" v-model="activeNames">
      <van-collapse-item v-for="(item, index) in ruleList" :key="index">
        <div slot="title">
          第{{ index+1 }}周（{{ weekList[index].start }}～{{ weekList[index].end }})
        </div>
        <div class="content" v-if="clazz.clazz_type==2">
          <div class="rule">
            <div class="item">任务：</div>
            <div class="item" v-if="item.breakfast">早餐打卡{{ item.breakfast }}次</div>
            <div class="item" v-if="item.lunch">午餐打卡{{ item.lunch }}次</div>
            <div class="item" v-if="item.dinner">晚餐打卡{{ item.dinner }}次</div>
            <div class="item" v-if="item.run.num">跑步训练{{ item.run.num }}次，每次{{ item.run.time }}分钟</div>
            <div class="item" v-if="item.train.num">技术/力量训练{{ item.train.num }}次，每次{{ item.train.time }}分钟</div>
          </div>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { Tag, Collapse, CollapseItem } from 'vant'
import { getCycleWeekRange } from '@/utils/index'

export default {
  name: 'CycleCuttingRule',
  components: {
    [Tag.name]: Tag,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  props: {
    clazz: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      activeNames: [],
      weekList: [],
      ruleList: []
    }
  },
  created () {
    this.ruleList = this.clazz.rule_content.ruleList
    this.getCycleWeekRange()
  },
  methods: {
    getCycleWeekRange () {
      this.weekList = getCycleWeekRange(this.clazz.start_time_format2, this.clazz.week_num)
      for (let index = 0; index < this.weekList.length; index++) {
        const week = this.weekList[index]
        if (week.current) {
          this.activeNames.push(index)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cycle_cutting_rule {
  .header {
    background-color: #343344;
    // background-color: #333a46;
    // background-color: #282c34;
    padding: 30px 30px;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info {
      .clazz_name {
        font-size: 30px;
        margin-bottom: 5px;
      }
      .cycle_range {
        color: #969696;
        font-size: 28px;
      }
    }
    .limit {
      font-size: 26px;
      display: flex;
      text-align: center;
      .limit_item {
        margin-left: 30px;
        font-size: 26px;
        .one {
          margin-bottom: 5px;
          span {
            font-size: 36px;
          }
        }
        .two {
          color: #969696;
          font-size: 24px;
        }
      }
    }
  }
  .clazz_cycle {
    .content {
      .item {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
